"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckboxGroup = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _Checkbox = require("../Checkbox/Checkbox");

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("../RadioGroup/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CheckboxGroup, _Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup() {
    var _this;

    (0, _classCallCheck2.default)(this, CheckboxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "values", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (e, value) {
      var checked = e.target.checked;
      checked ? _this.values[value] = checked : delete _this.values[value];
      var selected = Object.keys(_this.values);

      _this.props.onChange(e, selected);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      // onChange gets called twice if put onto the FormControl, so let's remove it from muiProps.
      var _this$props = _this.props,
          helperText = _this$props.helperText,
          onChange = _this$props.onChange,
          muiProps = (0, _objectWithoutProperties2.default)(_this$props, ["helperText", "onChange"]);
      var _this$props2 = _this.props,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          className = _this$props2.className,
          classes = _this$props2.classes;
      var selected = _this.props.value;
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, (0, _extends2.default)({}, muiProps, {
        className: (0, _classnames.default)("prmbl-checkboxGroup", className, classes.checkboxGroup)
      }), label && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        className: (0, _classnames.default)("prmbl-radioGroupLabel", classes.radioCheckGroupLabel)
      }, label), muiProps.options.map(function (o, i) {
        var _o = _objectSpread({}, o),
            label = _o.label,
            value = _o.value,
            checkboxProps = (0, _objectWithoutProperties2.default)(_o, ["label", "value"]);

        var checked = selected.find(function (w) {
          return w === o.value;
        }) != null;

        if (checked) {
          _this.values[o.value] = true;
        } else {
          delete _this.values[o.value];
        }

        return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
          id: "fcl-".concat(i),
          key: i,
          label: label,
          className: "prmbl-checkboxGroup-formControlLabel",
          control: /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, (0, _extends2.default)({}, checkboxProps, {
            checked: checked,
            value: o.value,
            onChange: _this.onChange,
            disabled: disabled
          }))
        });
      }, (0, _assertThisInitialized2.default)(_this)), helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, helperText));
    });
    return _this;
  }

  return CheckboxGroup;
}(_react.Component);

exports.CheckboxGroup = CheckboxGroup;
(0, _defineProperty2.default)(CheckboxGroup, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Disable all the checkboxes in the group
   */
  disabled: _propTypes.default.bool,

  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes.default.string.isRequired,

  /**
   * Callback fired when a Checkbox is selected.
   *
   * **Signature:**
   * `function(event: object, value: string) => void`
   * event: The event source of the callback. You can pull out the new value by accessing `event.target.value`.
   * *value*: The `value` of the selected radio button
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * The checkboxes that are to be made as part of this group.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The html id
     */
    id: _propTypes.default.string.isRequired,

    /**
     * If `true` the checkbox is checked
     */
    checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

    /**
     * Color for the checkbox
     */
    color: _propTypes.default.oneOf(["default", "primary", "secondary"]),

    /**
     * If `true` the checkbox is disabled
     */
    disabled: _propTypes.default.bool,

    /**
     * If `true` the checkbox is selected with the indeterminate icon `-`
     */
    indeterminate: _propTypes.default.bool,

    /**
     * Callback for the checkbox is clicked
     *
     * Signature: `function(event, checked) => void`
     * event: the originating event.
     * checked: the checked value of the switch
     */
    onChange: _propTypes.default.func,

    /**
     * @ignore
     *
     * Utilized By:
     * CivicEngage, CP Platform
     */
    className: _propTypes.default.string
  })).isRequired,

  /**
   * Array of the selected checkboxes
   */
  value: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   * The helper text to be displayed under the checkboxes
   */
  helperText: _propTypes.default.string,

  /**
   * The text to be used above the component to describe the checkbox group.
   */
  label: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(CheckboxGroup, "defaultProps", {
  className: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(CheckboxGroup);

exports.default = _default;